<template>
  <v-dialog
    v-model="showProcessDialog"
    persistent
    scrollable
    style="overflow: hidden"
    no-click-animation
    max-width="520px"
  >
    <v-card class="window-card" style="overflow: hidden; padding: 20px">
      <p>{{ textTitle }}</p>

      <v-form ref="form">
        <v-text-field
          v-if="rowData.status == 11"
          v-model="rowData.requirement_model_name"
          placeholder="请输入模型名称"
          label="模型名称"
        ></v-text-field>

        <!-- <v-select
        v-if="rowData.status == 11"
          v-model="rowData.requirement_device_type"
          :items="categoryList"
          item-text="name"
          item-value="code"
          color="#4caf50"
          label="类型 *"
          no-data-text="暂无数据"
          :rules="[v => !!v || '类型不能为空']"
        ></v-select>

        <v-select
        v-if="rowData.status == 11"
          v-model="rowData.requirement_modmajor_type"
          :items="majorListData"
        
          color="#4caf50"
          item-text="name"
          item-value="code"
          label="分类 *"
          no-data-text="暂无数据"
          :rules="[v => !!v || '专业分类不能为空']"
        ></v-select> -->

        <v-file-input
          v-if="rowData.status == 11"
          truncate-length="15"
          color="#4caf50"
          label="模型封面上传"
          @change="f => (form.mod_image_file = fileChange(f))"
          accept="image/*"
          show-size
          :value="form.mod_image_file"
        ></v-file-input>
        <p
          v-if="rowData.status == 11"
          style="
            color: red;
            margin-left: 20px;
            margin-bottom: 0px;
            font-size: 12px;
            transform: translateY(-10px);
          "
        >
          推荐尺寸为190(长)*340(宽)的封面图片
        </p>
        <v-file-input
          v-if="rowData.status == 11"
          truncate-length="15"
          color="#4caf50"
          label="模型上传"
          @change="f => (form.mod_file = fileChange(f))"
          show-size
          accept=".FBX,.fbx"
          :value="form.mod_file"
        ></v-file-input>

        <v-file-input
          v-if="rowData.status == 11"
          truncate-length="15"
          color="#4caf50"
          label="压缩包上传"
          @change="f => (form.mod_file_zip = fileChange(f))"
          show-size
          accept=".zip,.rar"
          :value="form.mod_file_zip"
        ></v-file-input>

        <v-textarea
          v-model="rejection"
          label="驳回理由"
          color="#4caf50"
          clearable
          rows="3"
          :rules="[v => !!v || '驳回理由不能为空']"
        ></v-textarea>
      </v-form>
      <v-card-actions md-alignment="right" style="margin-right: 0px">
        <v-spacer></v-spacer>
        <v-btn color="success" @click="agree" :loading="btnLoading">提交</v-btn>
        <v-btn color="error" @click="reject">驳回</v-btn>
        <v-btn color="gray" @click="cancel">关闭</v-btn>
      </v-card-actions>
    </v-card>

    <v-snackbar v-model="snackbar" :timeout="timeout" top color="red">
      请上传图片或文件
    </v-snackbar>
  </v-dialog>
</template>
<script>
import moment from 'moment';
import { upload, ossUpload } from '@/api/user';
import { userInfo } from '@/api/user';
import { updateModelStatus } from '@/api/model_resource';
export default {
  props: {
    showProcessDialog: {
      type: Boolean,
      default: false,
    },
    rowData: {
      type: Object,
      default: {},
    },
    textTitle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      majorListData: [],
      categoryList: [
        { name: '设备', code: 'device' },
        { name: '角色', code: 'role' },
        { name: '工具', code: 'tool' },
        { name: '场景', code: 'scene' },
      ],
      btnLoading: false,
      form: {
        mod_image_file: null,
        mod_file: null,
        mod_file_zip: null,
      },
      snackbar: false,
      timeout: 2000,
      rejection: '',
      projectFlag: false,
    };
  },
  components: {},
  created() {},
  computed: {},
  mounted() {
    // if (this.rowData) {
    //   if (this.rowData.model_image) {
    //     this.sliceUrl(this.rowData.model_image, 'img');
    //   }
    //   if (this.rowData.model_file) {
    //     this.sliceUrl(this.rowData.model_file, 'model');
    //   }
    // }
    this.initDict('device');
  },
  methods: {
    /**
     * 初始化字典
     */
    initDict(cate_type) {
      this.$dic.getCategoryList(
        {
          cate_type: cate_type,
          level: '1',
        },
        res => {
          this.majorListData = res;
        }
      );
    },
    // sliceUrl(url, type) {
    //   let index = url.lastIndexOf('/');
    //   let fileName = url.slice(index).replace('/', '');
    //   let acceptType = null;
    //   if (type == 'img') {
    //     acceptType = 'image/*';
    //   } else {
    //     acceptType = '.FBX,.fbx';
    //   }
    //   this.getFileFromUrl(url, decodeURIComponent(fileName), acceptType)
    //     .then(response => {
    //       if (type == 'img') {
    //         this.$set(this.form, 'mod_image_file', response);
    //       }
    //       if (type == 'model') {
    //         this.$set(this.form, 'mod_file', response);
    //       }
    //     })
    //     .catch(e => {
    //       console.error(e);
    //     });
    // },
    // getFileFromUrl(url, fileName, acceptType) {
    //   return new Promise((resolve, reject) => {
    //     var blob = null;
    //     var xhr = new XMLHttpRequest();
    //     xhr.open('GET', url);
    //     xhr.setRequestHeader('Accept', acceptType);
    //     xhr.responseType = 'blob';
    //     // 加载时处理
    //     xhr.onload = () => {
    //       // 获取返回结果
    //       blob = xhr.response;
    //       let file = new File([blob], fileName, { type: acceptType });
    //       // 返回结果
    //       resolve(file);
    //     };
    //     xhr.onerror = e => {
    //       reject(e);
    //     };
    //     // 发送
    //     xhr.send();
    //   });
    // },
    fileChange(e) {
      console.log({
        e,
        f: this.form,
      });
      return e;
    },
    async uploadFile(fieldName, file) {
      const res = await ossUpload({ path: fieldName, file });
      return res.url;
    },
    //获取当前登录人的userId
    getreceivingPresonId() {
      let userId = null;
      if (window.localStorage.getItem('USER_INFO')) {
        userId = JSON.parse(window.localStorage.getItem('USER_INFO')).user.userId;
      }
      return userId;
    },
    /**
     * 通过
     */
    async agree() {
      this.btnLoading = true;
      if (this.rowData.status !== 9 && this.rowData.status !== 14) {
        if (!this.form.mod_image_file) {
          this.snackbar = true;
              this.btnLoading  = false
          return;
        }
        if (!this.form.mod_file) {
          this.snackbar = true;
          this.btnLoading  = false
          return;
        }
      }
      let params = {};
      if (this.rowData.status == 9 || this.rowData.status == 14) {
        let receivingPreson = this.getreceivingPresonId();
        if (receivingPreson) {
          params.receivingPreson = receivingPreson;
        }
        params.status = 11;
        params._id = this.rowData._id;
        // params.devUserId = this.rowData.devUserId || '';
      }
      if (this.rowData.status == 11) {
        params._id = this.rowData._id;
        params.status = 12;
        // params.devUserId = this.rowData.devUserId || '';
        (params.requirement_model_name = this.rowData.requirement_model_name),
          (params.model_image = await this.uploadFile('modelImage', this.form.mod_image_file));
        params.model_file = await this.uploadFile('modelFile', this.form.mod_file);
        if(this.form.mod_file_zip){
          params.mod_file_zip = await this.uploadFile('mod_file_zip', this.form.mod_file_zip);
        }else{
          params.mod_file_zip = null
        }
      }
      updateModelStatus(params).then(res => {
        this.btnLoading = false;
        // console.log(res)
        if (res.code == '200') {
          this.$emit('cancel');
        }
      });

      // --->DevMod
      // this.$emit("handleAgree", { option: this.auditOpinion });
    },

    /*
      驳回
    */
    async reject() {
      if (!this.$refs.form.validate()) {
        this.projectFlag = true;
        return;
      } else {
        this.projectFlag = false;
      }

      let params = {};
      if (this.rowData.status == 11) {
        params.status = 9;
        params._id = this.rowData._id;
        params.rejection = this.rejection;
      }

      if (this.rowData.status == 9) {
        params.status = 8;
        params._id = this.rowData._id;
        params.rejection = this.rejection;
      }
      if (this.rowData.status == 14) {
        params.status = 9;
        params._id = this.rowData._id;
        params.rejection = this.rejection;
      }
      updateModelStatus(params).then(res => {
        if (res.code == '200') {
          this.$emit('cancel');
        }
      });
    },

    /**
     * 取消
     */
    cancel() {
      // --->DevMod
      this.$emit('cancel', false);
    },
  },
};
</script>
<style lang="scss" scoped>
.v-card .v-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
</style>
